"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const OsmosysDiv_1 = require("../utils/OsmosysDiv");
const react_if_1 = require("react-if");
const OsmosysIcon_1 = require("./OsmosysIcon");
const buttons_1 = require("../buttons");
exports.OsmosysPlaceholder = ({ withPicture = true, selectBox = false, height = selectBox ? 40 : undefined, icon = false, btn = false, minHeight = undefined, flexColFilled = false, children, }) => {
    if (icon === true) {
        icon = 'md';
    }
    if (btn) {
        return (react_1.default.createElement(OsmosysDiv_1.OsmosysDiv, { osysName: "OsmosysPlaceholder", className: "placeholder-shimmer ph-light", flexColFilled: flexColFilled },
            react_1.default.createElement(buttons_1.OsmosysButton, { osysName: "OsmosysPlaceholderButton", osysIcon: "square", iconStyle: "solid", osysStyle: btn, 
                // opacity={0.2}
                className: "text-muted", activeClassName: "text-muted", inactiveClassName: "text-muted", disabled: true }, children)));
    }
    if (icon) {
        return (react_1.default.createElement(OsmosysDiv_1.OsmosysDiv, { osysName: "OsmosysPlaceholder", className: "placeholder-shimmer ph-light", flexColFilled: flexColFilled },
            react_1.default.createElement(OsmosysIcon_1.OsmosysIcon, { osysIcon: "square", iconStyle: "solid", size: icon === 'md' ? undefined : icon })));
    }
    if (minHeight) {
        return (react_1.default.createElement(OsmosysDiv_1.OsmosysDiv, { style: { minHeight }, className: "w-100 ph-item ph-light rounded", flexColFilled: flexColFilled }));
    }
    if (height) {
        return (react_1.default.createElement(OsmosysDiv_1.OsmosysDiv, { style: { height }, className: "w-100 ph-item ph-light rounded", flexColFilled: flexColFilled }));
    }
    return (react_1.default.createElement(OsmosysDiv_1.OsmosysDiv, { osysName: "OsmosysPlaceholder", className: "placeholder-shimmer", flexColFilled: flexColFilled },
        react_1.default.createElement("div", { className: "ph-item" },
            react_1.default.createElement("div", { className: "ph-col-12" },
                react_1.default.createElement(react_if_1.When, { condition: withPicture },
                    react_1.default.createElement("div", { className: "ph-picture" })),
                react_1.default.createElement("div", { className: "ph-row" },
                    react_1.default.createElement("div", { className: "ph-col-6 big" }),
                    react_1.default.createElement("div", { className: "ph-col-3 empty big" }))))));
};
//# sourceMappingURL=OsmosysPlaceholder.js.map